import { Avatar } from "@mui/material";
import { hasAvatar, ICON_AVATARS, isLogoKind, type PickerKind } from "./config";
import type { PickerEntity } from "./entity";
import { logoUrl } from "../../api/logo";

/**
 * Renders the leading visual for a picker entity. Returns `null` when the
 * kind opts out of avatars (see `hasAvatar`); callers should check before
 * allocating a layout slot for it.
 */
export const EntityAvatar = ({
  kind,
  entity,
  size = 24,
}: {
  kind: PickerKind;
  entity: PickerEntity;
  size?: number;
}) => {
  if (!hasAvatar(kind)) return null;

  const iconConfig = ICON_AVATARS[kind];
  if (iconConfig) {
    const { Component: Icon, color } = iconConfig;
    return (
      <Avatar
        alt={entity.name}
        sx={{
          width: size,
          height: size,
          bgcolor: "transparent",
          color,
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Icon sx={{ fontSize: size * 0.7 }} />
      </Avatar>
    );
  }

  if (isLogoKind(kind)) {
    return (
      <Avatar
        src={logoUrl(kind, entity)}
        alt={entity.name}
        sx={{
          width: size,
          height: size,
          bgcolor: entity.colorBg || undefined,
          color: entity.colorFg || undefined,
          fontSize: size <= 24 ? "0.75rem" : "0.9rem",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        {entity.name.slice(0, 2).toUpperCase()}
      </Avatar>
    );
  }

  return null;
};
